<template>
  <div class="edit-form">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-ext-upload ></a-ext-upload>
      <a-form-model-item ref="name" label="字段1" prop="field1">
        <a-input
          v-model="form.field1"
          placeholder="请输入文本框内容"
          @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item label="字段2">
        <a-input  placeholder="请输入密码333" autocomplete="off" v-model="sss" />
      </a-form-model-item>

      <a-row>
        <a-col :span="24">
      <a-form-model-item prop="fieldArr">
        <a-ext-task-s-k-d-pick-and-check v-model="form.fieldArr"></a-ext-task-s-k-d-pick-and-check>
      </a-form-model-item>
        </a-col>
      </a-row>
<a-row>
  <a-col :span="12">
      <a-form-model-item label="9999999">
        <a-ext-array-edit-demo v-model="form.fieldArr"></a-ext-array-edit-demo>
      </a-form-model-item>
  </a-col>
  <a-col :span="12">
      <a-form-model-item label="吱吱吱吱艾孜孜 " prop="fieldObj">
        <objdemo v-model="form.fieldObj"></objdemo>
      </a-form-model-item>
  </a-col>
</a-row>
      <a-form-model-item label="字段332">
        <a-input v-model="form.field2" type="password" placeholder="请输入密码" autocomplete="off" />
      </a-form-model-item>
      <a-form-model-item label="字段3" prop="field3">
        <a-input v-model="form.field3" type="password" placeholder="请再次输入密码" autocomplete="off" />
      </a-form-model-item>
      <a-form-model-item label="字段4" prop="field4">
        <a-cascader v-model="form.field4" :options="field4Options" placeholder="请选择级联选择内容" />
      </a-form-model-item>
      <!--<a-form-model-item label="字段5" required prop="field5">-->
        <!--<a-date-picker v-model="form.field5" show-time type="date" placeholder="选择时间" style="width: 100%" />-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item label="字段6" prop="field6">-->
        <!--<a-checkbox-group v-model="form.field6" :options="field6Options"></a-checkbox-group>-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item label="字段7" prop="field7">-->
        <!--<a-radio-group v-model="form.field7" :options="field7Options"></a-radio-group>-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item label="字段8" prop="field8">-->
        <!--<a-input v-model="form.field8" type="textarea" placeholder="请输入富文本框内容" />-->
      <!--</a-form-model-item>-->
      <!--<a-form-model-item label="字段9" prop="field9">-->
        <!--<a-select v-model="form.field9" show-search placeholder="请选择可搜索下拉框数据" option-filter-prop="children" style="width: 100%" :filter-option="filterOption">-->
          <!--<a-select-option v-for="item in field9Options" :value="item.value" :key="item.value"> {{ item.label }} </a-select-option>-->
        <!--</a-select>-->
      <!--</a-form-model-item>-->
      <a-form-model-item label="字段10" prop="field10">
        <a-select v-model="form.field10" placeholder="请选择下拉框数据" style="width: 100%">
          <a-select-option v-for="item in field10Options" :value="item.value" :key="item.value"> {{ item.label }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="字段11" prop="field11">
        <a-auto-complete v-model="form.field11" placeholder="请输入网址" @change="handleWebsiteChange">
          <template slot="dataSource">
            <a-select-option v-for="website in autoCompleteResult" :key="website">
              {{ website }}
            </a-select-option>
          </template>
          <a-input />
        </a-auto-complete>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button v-perm="'ssss'" type="primary" @click="onSubmit"> 提交 </a-button>
        <a-button style="margin-left: 10px" @click="resetForm"> 重置 </a-button>
      </a-form-model-item>
    </a-form-model>
      <form-model v-if="testvis" :visible.sync="testvis"></form-model>
  </div>
</template>

<script>
import axios from 'axios';
import objdemo from '../AntDesignExt/Demo/AExtObjEditDemo'
import AExtArrayEditDemo from '../AntDesignExt/Demo/AExtArrayEditDemo'
import AExtTaskSKDPickAndCheck from '../AntDesignExt/AExtTaskSKDPickAndCheck/index'
import AExtUpload from '../AntDesignExt/Demo/AExtUpload'
import FormModel from '../EditForm/FormModel'
export default {
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.field2) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

      let validatePass3 = (rule, value, callback) => {
          if (value.field1 === '') {
              callback(new Error('ssssssssssssss'));
          }
          else
          {
              callback();
          }
      };

      let validatePass4 = (rule, value, callback) => {
          if (value.length>0&&value[0].taskName) {
              callback(new Error('ssssssssssssss'));
          }
          else
          {
              callback();
          }
      };

    return {
        sss:'ssssss',
      labelCol: { span: 2 },
      wrapperCol: { span: 8 },
        testvis:false,
      form: {
        field1: '',
        field2: '',
        field3: '',
        field4: undefined,
        field5: undefined,
        field6: [],
        field7: '',
        field8: '',
        field9: '',
        field10: '',
        field12: '',
          fieldObj:{field1:'111',field2:'888888'},
          fieldArr:[{value:'1'},{value:'2'},{value:'1'},{value:'2'}]
      },
      rules: {
        field1: [
          { required: true, message: '请输入文本框内容', trigger: 'blur' },
          { min: 3, max: 50, message: '内容长度在3-50', trigger: 'blur' },
        ],
        field2: [
          {
            required: true,
            message: '请输入密码!',
          },
        ],
        field3: [{ validator: validatePass2, trigger: 'change' }],
        field4: [{ required: true, message: '请选择级联选择内容!', trigger: 'change' }],
        field5: [{ required: true, message: '选择时间', trigger: 'change' }],
        field6: [
          {
            type: 'array',
            required: true,
            message: '请选择字段4',
            trigger: 'change',
          },
        ],
        field7: [{ required: true, message: '请选择字段5', trigger: 'change' }],
        field8: [
          { required: true, message: '请输入富文本框内容', trigger: 'blur' },
          { min: 3, max: 50, message: '内容长度在3-50', trigger: 'blur' },
        ],
        field9: [{ required: true, message: '请选择可搜索下拉框数据', trigger: 'change' }],
        field10: [{ required: true, message: '请选择下拉框数据', trigger: 'change' }],
        field11: [{ required: true, message: '请输入网址!' }],
          fieldObj: [{ validator: validatePass3, trigger: 'change' }],
          fieldArr:[{ validator: validatePass4, trigger: 'change' }]
      },
      // 级联选择下拉框数据
      field4Options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
          children: [
            {
              value: 'hangzhou',
              label: 'Hangzhou',
              children: [
                {
                  value: 'xihu',
                  label: 'West Lake',
                },
              ],
            },
          ],
        },
        {
          value: 'jiangsu',
          label: 'Jiangsu',
          children: [
            {
              value: 'nanjing',
              label: 'Nanjing',
              children: [
                {
                  value: 'zhonghuamen',
                  label: 'Zhong Hua Men',
                },
              ],
            },
          ],
        },
      ],
      // 多选组数据
      field6Options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
        },
        {
          value: 'shandong',
          label: 'shandong',
        },
        {
          value: 'henan',
          label: 'henan',
        },
      ],
      // 单选组数据
      field7Options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
        },
        {
          value: 'shandong',
          label: 'shandong',
        },
        {
          value: 'henan',
          label: 'henan',
        },
      ],
      // 可搜索选择下拉框数据
      field9Options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
        },
        {
          value: 'shandong',
          label: 'shandong',
        },
        {
          value: 'henan',
          label: 'henan',
        },
      ],
      // 选择下拉框数据
      field10Options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
        },
        {
          value: 'shandong',
          label: 'shandong',
        },
        {
          value: 'henan',
          label: 'henan',
        },
      ],
      // 网址后缀数组
      autoCompleteResult: [],
    };
  },
  mounted() {
    this.init();
  },
    components:{
        AExtArrayEditDemo,AExtTaskSKDPickAndCheck,AExtUpload,FormModel,
      objdemo
    },
    created(){

    },
  methods: {
    init() {
      // let params = { results: 10, page: 1 };
      // axios.get('https://randomuser.me/api', { params: params }).then(({ data }) => {
      //   this.form = {
      //     field1: '',
      //     field2: '',
      //     field3: '',
      //     field4: undefined,
      //     field5: undefined,
      //     field6: [],
      //     field7: '',
      //     field8: '',
      //     field9: '',
      //     field10: '',
      //     field12: '',
      //   };
      // });
    },
    // 下拉搜索
    filterOption(input, option) {
      return option.componentOptions.children[0].text.indexOf(input || input.toLowerCase()) >= 0;
    },
    // 网址后缀
    handleWebsiteChange(value) {
      let autoCompleteResult;
      if (!value) {
        autoCompleteResult = [];
      } else {
        autoCompleteResult = ['.com', '.org', '.net'].map((domain) => `${value}${domain}`);
      }
      this.autoCompleteResult = autoCompleteResult;
    },
    // 提交
    onSubmit() {
        console.log(this.form)
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submitData()
        } else {
          return false;
        }
      });
    },
    // 重置
    resetForm() {
        this.testvis=true;
        return;
        console.log(this.form)
      this.$refs.ruleForm.resetFields();
    },
    // 提交数据
    submitData() {
      axios.post('http://112.124.27.40:7788/api/v1/ziyuan//mvc/data-analaysis/get-detail', { data: this.form }).then(({ data }) => {
        this.resetForm()
      }).catch(err => {
        this.resetForm()
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
